module.exports = __webpack_public_path__ + "img/mel-dlja-doski.c0d6c09e.svg";